import { ArrowRightOutlined, ClockCircleFilled, DashboardFilled } from '@ant-design/icons'
import { FlagIcon, TransportationOrderFlag } from '@components/_SiteWide/Flags/FlagIcon'
import { StoreCityStateList } from '@components/_SiteWide/OrderDisplay/StoreCityStateList'
import { DispatchWindowPopover } from '@components/OrderDispatch/TripGrid/TripGridCell/DispatchWindowPopover'
import { TripStatusHover } from '@components/OrderDispatch/TripGrid/TripGridCell/TripStatus'
import { BBDTag, GraviButton, Horizontal, MaterialIcon, Texto, Vertical } from '@gravitate-js/excalibrr'
import classNames from 'classnames'
import moment from 'moment'
import React, { useMemo } from 'react'

import { FlagIconSwitch, FlagIconSwitch2 } from '../../../../_SiteWide/Flags/FlagIconSwitch'

export function ExplicitView({
  trip,
  currentStatusClass,
  status,
  cardErrors,
  hideClass,
  isBackhaul,
  setOrderHistoryStoreId,
  flags,
  handleFlagResolve,
}) {
  const firstCardError = cardErrors?.[0]

  const retainStatus = useMemo(() => cardErrors.find((error) => error.type === 'retain')?.status, [cardErrors])
  const runoutStatus = useMemo(() => cardErrors.find((error) => error.type === 'runout')?.status, [cardErrors])
  const hasCompHold = useMemo(() => flags?.some((flag) => flag.type === 'compliance_hold'), [flags])

  const buttonText = (
    <Horizontal verticalCenter gap={6}>
      <Vertical flex={0} verticalCenter style={{ overflow: 'visible', fontSize: '1.2em' }}>
        {firstCardError ? (
          <FlagIconSwitch2 isOrderFlag view='tripGridCell' flag={firstCardError} />
        ) : (
          <ClockCircleFilled />
        )}
      </Vertical>
      <span style={{ textDecoration: retainStatus ? 'underline' : 'none' }}>
        {moment(trip?.dispatch_window_start).format('M/D H:mm')}
      </span>
      {' - '}
      <span style={{ textDecoration: runoutStatus ? 'underline' : 'none' }}>
        {moment(trip?.dispatch_window_end).format('M/D H:mm')}
      </span>
    </Horizontal>
  )

  return (
    <Vertical
      className={classNames('p-1 pr-2 card-body', currentStatusClass)}
      style={{
        borderRadius: '0 6px 6px 0',
        ...(!runoutStatus && !hasCompHold && !retainStatus && { border: '1px solid var(--gray-300)' }),
      }}
    >
      <Horizontal verticalCenter flex={1}>
        <Vertical flex={status ? 3 : null} alignItems='start' verticalCenter>
          <StoreCityStateList order={trip} setOrderHistoryStoreId={setOrderHistoryStoreId} explicitView />
        </Vertical>
        {!!status && (
          <Vertical
            flex={1}
            className='status-icons'
            style={{ overflow: 'visible' }}
            alignItems='flex-end'
            verticalCenter
          >
            <TripStatusHover status={status} trip={trip} currentStatusClass={currentStatusClass} />
          </Vertical>
        )}
      </Horizontal>

      <Horizontal verticalCenter flex={1} className='pb-0 pt-1 pl-1'>
        <Vertical flex={1.19} verticalCenter justifyContent='space-between' style={{ maxWidth: '83px' }}>
          <Texto weight={700}>
            <Horizontal verticalCenter>
              <MaterialIcon icon='search_hands_free' className='mr-2' />
              {parseInt(trip?.turn_time.split(':')[0]) > 0 && parseInt(trip?.turn_time.split(':')[0])}h{' '}
              {parseInt(trip?.turn_time.split(':')[1])}
            </Horizontal>
          </Texto>
        </Vertical>
        <Vertical verticalCenter alignItems='flex-end' flex={2.8}>
          <DispatchWindowPopover
            isExplicitView
            hoverTriggerItem={buttonText}
            order={trip}
            cardErrors={cardErrors}
            hideClass={hideClass}
            isBackhaul={isBackhaul}
          />
        </Vertical>
      </Horizontal>

      <Horizontal flex={1} className={trip?.loads?.length > 2 ? 'pl-1 pr-1 pb-2' : 'pl-1 pr-1'}>
        <Vertical className='pl-1' flex={3} justifyContent='center' alignItems='start'>
          <DeliveryViewOrderTerminals order={trip} />
        </Vertical>
        <Vertical justifyContent='center' alignItems='flex-end' flex={1}>
          <div className='clock-icon'>
            {isBackhaul ? (
              <TransportationOrderFlag />
            ) : (
              <>
                {flags?.length > 0 && (
                  <FlagIcon
                    flags={flags}
                    orderId={trip.order_id}
                    orderNumber={trip.number}
                    updateOrder={handleFlagResolve}
                    view='tripGridCell'
                  />
                )}
              </>
            )}
          </div>
        </Vertical>
      </Horizontal>
    </Vertical>
  )
}

export function DeliveryViewOrderTerminals({ order }) {
  if (!order.loads) return null

  return (
    <Horizontal style={{ width: '100%', color: 'var(--gray-700)', flexWrap: 'wrap', fontSize: '11px' }} verticalCenter>
      {order.loads.map((d, i) => {
        const locationName = d.location_short_name || d.location_name
        const showArrow = i !== order.loads.length - 1
        return (
          <React.Fragment key={i}>
            {locationName}
            {showArrow && <ArrowRightOutlined style={{ color: 'var(--theme-color-2)' }} className='pl-1 pr-2' />}
          </React.Fragment>
        )
      })}
    </Horizontal>
  )
}
